/* tempexp_18086-start */
import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import type { ReferralPromoModalProps } from 'reactApp/ui/ReferralProgram/ReferralPromoModal/ReferralPromoModal';

export const renderReferralModalPromo = ({ onClose, ...data }: ReferralPromoModalProps) =>
    openPopupHelper({ popupName: popupNames.REFERRAL_MODAL_PROMO, data, onClose });

export const closeReferralModalPromo = () => closePopupHelper(popupNames.REFERRAL_MODAL_PROMO);

/* tempexp_18086-end */
